import { hasHidden } from "@/shared/value";
import { toProcessRouteStepFormValue } from "@/shared/form/process-route-step-input";
import { EditPathInputDataFragment, ProcessRouteStepInput } from "gql/graphql";

/** Значение шага в форме маршрута: `id` остаётся только ключом строки перетаскивания в `PathInput`. */
export type PathStepFormValue = ProcessRouteStepInput & { id: string };

export function transformEditPathInputDataToProcessRouteStepInput(
  path: EditPathInputDataFragment,
): PathStepFormValue {
  return { id: path.id, ...toProcessRouteStepFormValue(path) };
}

/**
 * Есть ли в маршруте шаг с закрытой защитой персоной.
 *
 * У такого шага `person` разворачивается в `undefined`, тип шага перестаёт определяться,
 * и поле с `required` даже не монтируется — маршрут молча сохраняется пустым шагом.
 */
export function routeHasHiddenSteps(
  route: EditPathInputDataFragment[],
): boolean {
  return hasHidden([
    ...route.map((step) =>
      step.__typename === "PersonProcessRouteStepDto" ? step.person : null,
    ),
  ]);
}
